import { useStore } from 'store';

export const useCheckCanAr = () => {
  const intent = useStore((state) => state.hrx.intent);

  const canAr = intent === 'willQL' || intent === 'canQL' || intent === 'willSV' || intent === 'canSV';

  return canAr;
};
